import React, { Component } from "react";
import { observer } from "mobx-react";

import moment from "moment";
import { comma, partnerIcon, getOrderInfoText, getChannelMobileOrderNo } from "../../../utils/Utils";
import { fn_orderDetail, fn_orderEndDetail } from "../../../function/FnBodyDetail";

@observer
class EndOrderItemView extends Component {
  render() {
    const { rootStore, order } = this.props;
    if (order.partnerType == "BAEMIN") {
      if (order.morderTypeCd == "P") {
        order.partnerType = "BAEMIN_PICKUP";
      } else if (order.morderTypeCd == "O") {
        order.partnerType = "BAEMIN_SHOP";
      }
    }
    let img_icon = partnerIcon(order.partnerType);
    let channelMobileOrderNo = getChannelMobileOrderNo(order);
    let infoText = getOrderInfoText(order) ? getOrderInfoText(order) : "주문자 정보가 없습니다";

    if (infoText.length > 30) {
      infoText = infoText.substring(0, 30) + "...";
    }

    return (
      <tr
        onClick={event => {
          event.preventDefault();
          fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrder");
        }}
      >
        <td className="date">{moment(order.orderTime, "YYYYMMDDHHmmss").format("MM/DD HH:mm")}</td>
        <td className="date">
          {order.completeTime == null && order.cancelTime == null
            ? ""
            : order.cancelTime != null
            ? moment(order.cancelTime, "YYYYMMDDHHmmss").format("HH:mm")
            : moment(order.completeTime, "YYYYMMDDHHmmss").format("HH:mm")}
        </td>
        <td className="channel_num">{channelMobileOrderNo}</td>
        <td className="pos_num">{order.orderNo.slice(-4)}</td>
        <td className="pos_n">{order.billNo}</td>
        <td className="type">{order.orderTypeView}</td>
        <td className="cahnnel">
          <div className="thumb">
            <img src={img_icon} width="30" height="30" alt={"logo"} />
            <span className="frame"></span>
          </div>
        </td>
        <td className="name">
          {/* {menuText}{(Number(order.mainMenuCount - 1) > 0) ? " 외 " + Number(order.mainMenuCount - 1) + "개" : null} */}
          {/*{order.prodCardView}*/}
          {/*{order.viewProdNm}{(order.viewProdCnt-1)>0?' 외 '+(order.viewProdCnt-1)+'개':null}*/}
          {infoText}
        </td>
        <td className="pay">
          {comma(order.orderAmount)}원{order.isPartialCanceled ? <span className="cancelIco"></span> : null}
        </td>
        <td className="means">{order.payTypeView.replaceAll("(", "").replaceAll(")", "")}</td>
        <td className="state">{order.stepCd === "700" ? "완료" : "취소"}</td>
      </tr>
    );
  }
}

export default EndOrderItemView;
